<template>
  <div>
    <el-dialog v-model="open" width="763" :show-close="false" destroy-on-close @close="closeDialog">
      <template #header="{ close, titleId, titleClass }">
        <div class="dialog-header">
          <h3 :id="titleId" :class="titleClass">{{ title }}</h3>
          <el-button class="close-btn" @click="close">
            <el-icon :size="16"><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <div class="body-box">
        <div>
          <el-input v-model="searchParams" clearable style="width: 200px" @keyup.enter="queryData" />
          <el-button type="default" plain :loading="loading" style="margin-left: 20px" @click="queryData">搜索</el-button>
          <el-button type="default" plain @click="clearSearch">清空</el-button>
        </div>
        <p style="line-height: 20px; font-size: 12px; color: #314a6f">可以输入名称或工号进行模糊搜索</p>
        <div class="table-box">
          <vxe-table
            ref="singleTableRef"
            :row-config="{ keyField: 'id', height: '45px' }"
            :radio-config="{ checkRowKey: checkRowKey, reserve: reserve }"
            border
            max-height="400px"
            :loading="loading"
            :data="tableData"
            @radio-change="changeRadio"
          >
            <vxe-column align="center" type="radio" width="60px" />
            <vxe-column title="名称" align="center" field="name" />
            <vxe-column title="员工工号" align="center" field="employeeNum" />
            <vxe-column v-if="props.type != 2" title="所属区域" align="center" field="regionName" />
            <vxe-column v-if="props.type != 2" title="校区名称" align="center" field="schoolName" />
            <vxe-column title="所属部门" align="center" field="departmentName" />
          </vxe-table>
          <pagination
            :hidden="!total"
            :total="total"
            layout="total, prev, pager, next"
            v-model:page="pageInfo.pageNum"
            v-model:limit="pageInfo.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="confirm">确定</el-button>
          <el-button type="primary" @click="closeDialog">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup name="userPopupModal">
import { getUserPopUpList } from '@/api/popup/index';

const props = defineProps({
  visible: {
    type: Boolean,
    require: true,
    default: false,
  },
  title: {
    type: String,
    require: true,
    default: '',
  },
  defaultKey: {
    type: String,
    default: '',
  },
  params: {
    type: Object,
    default: () => {}
  },
  type: {
    type: Number,
    default: 1 // 1 职业规划顾问 2 市场人员
  }
});
const emits = defineEmits(['update:visible', 'getInfo']);

const open = ref(false); //弹框是否开启动
const searchParams = ref(''); //查询参数
const pageInfo = reactive({
  pageNum: 1,
  pageSize: 50,
});
const total = ref(0); //总条数
const tableData = ref([]); //表格数据
const loading = ref(false); //数据加载中
const singleTableRef = ref(); //表格dom
const currentRow = ref({}); //当前的选取项目
const checkRowKey = ref(''); //默认选中的节点
const reserve = ref(false); //是否永久保存

watch(
  () => props.visible,
  (val) => {
    if (val) {
      open.value = val;
      reserve.value = true;
      checkRowKey.value = props.defaultKey;
      queryData();
    }
  }
);
//点击查询按钮
function queryData() {
  pageInfo.pageNum = 1;
  getList();
}
//请求表格数据
async function getList() {
  loading.value = true;
  const res = await getUserPopUpList(Object.assign({}, pageInfo, { nameOrNo: searchParams.value }, props.params));
  loading.value = false;
  tableData.value = res.rows;
  total.value = res.total;
}
//重置
function clearSearch() {
  reserve.value = false;
  singleTableRef.value.clearRadioRow();
  searchParams.value = '';
  currentRow.value = {};
  queryData();
}

//单选框改变时
function changeRadio({ row }) {
  reserve.value = true;
  currentRow.value = Object.assign({}, toRaw(row));
}

//点击确认按钮弹框
function confirm() {
  if (!reserve.value || currentRow.value.id) {
    emits('getInfo', currentRow.value);
  }
  closeDialog();
}
/**关闭弹框 */
function closeDialog() {
  searchParams.value = '';
  currentRow.value = {};
  open.value = false;
  emits('update:visible', false);
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  .el-dialog__header {
    padding: 0 20px;
    margin: 0;
    border-bottom: 1px solid #797979;
    .dialog-header {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 43px;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-dialog__title {
        width: fit-content;
        margin: 0;
        font-size: 18px;
        font-weight: 700;
      }
      .close-btn {
        position: absolute;
        right: 0;
        width: 25px;
        height: 25px;
        padding: 0;
        border-radius: 50%;
      }
    }
  }
  .el-dialog__footer {
    width: 100%;
    border-top: 1px solid #797979;
    .dialog-footer {
      display: flex;
      justify-content: center;
      .el-button {
        width: 80px;
        height: 29px;
        background-color: #027db4;
      }
    }
  }
}
</style>
